import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { DID_CLASS, DID_TYPE, DID, VerificationData, OrderDidRequest } from 'voxloud-types/dist/models';
import { DidsService, VerificationDataService } from 'src/app/domains/dids/services';

@Component({
  selector: 'gdp-replace-with-new-did-popup',
  templateUrl: './replace-with-new-did-popup.component.html',
  styleUrls: ['./replace-with-new-did-popup.component.scss']
})
export class ReplaceWithNewDidPopupComponent implements OnInit {
  public did: DID;
  public verificationDataList: VerificationData[] = [];
  public companyId: number;
  public form: UntypedFormGroup;
  public availableClasses = Object.keys(DID_CLASS);
  public availableTypes = Object.keys(DID_TYPE);
  public loading = {
    initialValues: false,
    submit: false
  };
  public showVerificationData: boolean = false;
  @Output() onReplaceDid: EventEmitter<string> = new EventEmitter();
  public currentLanguage: string;

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private didsService: DidsService,
    private verificationDataService: VerificationDataService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.currentLanguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe(l => this.currentLanguage = l.lang);

    this.form = this.fb.group({
      oldPhone: [this.did.number],
      country: [this.getCorrectCountryName(this.did.country), [Validators.required]],
      class: [this.did.did_class || DID_CLASS.FAX, [Validators.required]],
      type: [DID_TYPE.GEOGRAPHIC, [Validators.required]],
      prefix: [null, [Validators.required]],
      couponId: [null],
      verificationData: [null, [Validators.required]]
    });
    this.getInitialValues();
  }

  getInitialValues() {
    this.loading.initialValues = true;
    forkJoin({
      verificationDataList: this.verificationDataService.getVerificationDataByCompanyId(this.companyId)
    })
      .subscribe((res: any) => {
        this.verificationDataList = res.verificationDataList;

        if (res.verificationDataList.length > 0) {
          this.form.get('verificationData').setValue(
            this.verificationDataList[0]
          );
        }
        this.loading.initialValues = false;
      });
  }

  get verificationData() {
    return this.form.value.verificationData;
  }

  isFieldValid(name: string) {
    return (
      !this.form.get(name).valid && this.form.get(name).touched
    );
  }

  selectCountry(country: string) {
    this.form.get('country').setValue(country);
  }

  selectClass(value: string) {
    this.form.get('class').setValue(value);
  }

  selectType(type: string) {
    this.form.get('type').setValue(type);
  }

  selectVerificationData(data: VerificationData) {
    this.form.get('verificationData').setValue(data);
  }

  getCorrectCountryName(prefix: string) {
    return this.translate.instant(`company.dids.replace-with-did.popup.form.country.${prefix.toLowerCase()}`);
  }

  onSubmit() {
    if (this.form.valid) {
      const value = this.form.value;
      let request: OrderDidRequest = {
        area_code: value.prefix.code,
        country_code: this.did.country,
        did_type: value.type,
        did_class: value.class,
        did_number_to_replace: value.oldPhone,
        verification_data_id: value.verificationData.id,
        source_verification_data_id: undefined
      }
      this.loading.submit = true;
      this.didsService.orderDid(this.companyId, request).subscribe((res: string) => {
        this.onReplaceDid.emit(res);
        this.loading.submit = false;
        this.close();
      }, () => {
        this.loading.submit = false;
        this.close();
      });
    }
  }

  close() {
    this.activeModal.close();
  }

}
